export default __webpack_public_path__ + "static/media/snowuns-bg.0ba4ec95.webp";